<template>
  <div
    class="header_mid default_mid_header"
    data-height="110"
    style="position: sticky; position: -webkit-sticky; top: 0"
  >
    <!--style="height: 110px;"-->
    <div class="header_mid_outer">
      <div class="header_mid_inner">
        <MenuMobileButton />
        <HeaderSearchMobile />
        <HeaderLogo />
        <MiniCart />
        <MiniCartMobile />
        <ContactsLinkMobile />
        <RepairLinkMobile />
        <SearchBarFly />
        <!-- <HeaderMenu /> -->
        <!-- <SearchBar /> -->
        <HeaderMenuMobile />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import HeaderLogo from '@/components/header/HeaderLogo'
import MiniCart from '@/components/cart/MiniCart'
import MenuMobileButton from '@/components/header/MenuMobileButton'
// import HeaderMenu from '@/components/header/HeaderMenu' //move menu to top
// import SearchBar from '@/components/search/SearchBar'
import SearchBarFly from '@/components/search/SearchBarFly'
import MiniCartMobile from '@/components/cart/MiniCartMobile'
import HeaderSearchMobile from '@/components/header/HeaderSearchMobile'
import HeaderMenuMobile from '@/components/header/HeaderMenuMobile'
import ContactsLinkMobile from '@/components/header/ContactsLinkMobile'
import RepairLinkMobile from '@/components/repair/RepairLinkMobile'

export default {
  name: 'HeaderMiddle',
  components: {
    HeaderLogo,
    MiniCart,
    MenuMobileButton,
    // HeaderMenu, //move menu to top
    // SearchBar,
    SearchBarFly,
    MiniCartMobile,
    HeaderSearchMobile,
    HeaderMenuMobile,
    ContactsLinkMobile,
    RepairLinkMobile,
  },
  computed: mapState(['menuMobile']),
  mounted() {
    let header = document.querySelector('#header')
    let middle = document.querySelector('#middle')
    let topMargin = 106 + 'px 0 0 0'
    const updateStickyMenu = () => {
      setTimeout(() => {
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          header.classList.add('static-header')
          middle.style.margin = topMargin
        } else {
          header.classList.remove('static-header')
        }
      })
    }
    updateStickyMenu()
    window.addEventListener('resize', () => {
      updateStickyMenu()
    })
  },
}
</script>

<style>
.header_mid {
  position: relative;
  z-index: 1000;
}
</style>
